import React from 'react';
import RestCreate from 'containers/rest/Create';
import Form from '../components/Form';

const breadcrumbs = [
  {
    title: 'Users',
    href: '/users',
  },
  {
    title: 'common.page.create',
  },
];

const CreateUser = () => {
  return (
    <RestCreate
      model="users"
      breadcrumbs={breadcrumbs}
      hasSelectFilter={false}
      formatOnSubmit={(values) => ({
        ...values,
        locationCode: values?.locationCode?.length
          ? values?.locationCode?.map((item) => item?.id).join(',')
          : null,
        chainStore: values?.chainStore?.length
          ? values?.chainStore?.map((item) => item?.id).join(',')
          : null,
        isActive: !!values.isActive,
      })}
      customPathAfterSubmit="users"
      customUrlBack="/users"
    >
      <Form />
    </RestCreate>
  );
};

export default CreateUser;
